import { useEffect, useState } from "react";
import {
    queryCurrencies,
    QueryCurrencyResponse,
} from "./currency-service";

export type ApiCallState<TResponse> = {
    loading: boolean;
    error: Error | null;
    data: TResponse | null;
    refresh?: () => void | undefined;
};

export function useQueryCurrencies() {
    const [state, setState] = useState<ApiCallState<QueryCurrencyResponse>>({
        data: null as any,
        error: null as any,
        loading: false,
    });
    const [refreshIndex, setRefreshIndex] = useState(0);

    useEffect(() => {
        setState({ data: null as any, error: null as any, loading: true });
        (async () => {
            try {
                const data = await queryCurrencies();
                setState({ data, error: null, loading: false });
            } catch (error) {
                setState({ data: null, error, loading: false });
            }
        })();
    }, [refreshIndex]);

    return {
        ...state,
        refresh: () => setRefreshIndex(refreshIndex + 1),
    };
}